import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-subscription-cancel',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './subscription-cancel.component.html',
  styleUrl: './subscription-cancel.component.css',
})
export class SubscriptionCancelComponent {
  constructor(private router: Router) {}

  goToDashboard(): void {
    this.router.navigate(['/my-garage']);
  }
}
